const flourish = {
  studioId: 'flourish',
  studioName: 'Flourish Yoga',
  apiBaseUrl: 'https://flourishyoga.studio/api',
  siteUrl: 'https://flourishyoga.studio',
  // Studios sharing this backend; the class form shows a Studio picker when there's more than one.
  sharedStudios: [{ id: 'iy-sp', label: 'IY-SP' }, { id: 'flourish', label: 'Flourish' }],
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  zoomHostLink: process.env.REACT_APP_ZOOM_HOST_LINK,
  theme: {
    '--primary-hue':           '20',
    '--grey-hue':              '25',
    '--color-primary':         'hsl(20, 50%, 92%)',
    '--color-primary-variant': 'hsl(20, 75%, 50%)',
    '--color-secondary':       '#E06B52',
    '--color-tertiary':        '#c0512d',
    '--color-hybrid':          '#9AAB85',
    '--color-grey-100':        'hsl(25, 30%, 94%)',
    '--color-grey-200':        'hsl(25, 20%, 78%)',
    '--color-grey-300':        'hsl(25, 16%, 64%)',
    '--color-grey-400':        'hsl(25, 12%, 42%)',
    '--color-grey-500':        'hsl(25, 18%, 26%)',
    '--color-grey-600':        'hsl(25, 22%, 16%)',
  },
  venues: [
    { id: "venue_001", name: "Flourish Yoga Studio", address: "D-106, 6798 Crosswinds Dr N, St. Petersburg, FL 33710" },
    { id: "venue_online", name: "Online", address: null },
  ],
};

export default flourish;
